<template>
    <div class="-m-5 md:m-0 h-full flex-1 overflow-hidden">
        <tabulator
            :columns="columns"
            :actions="actions"
            :refresh.sync="refreshTable"
            ajax-path="sip/rules"
            @rowSelected="handleRowSelected"
            @ajaxResponse="(response) => {
                $store.commit('sip/rules/setItems', response);
            }"
        />
        <app-modal
            width="lg:w-1/3"
            :show.sync="showAddModal"
        >
            <template slot="header">Add Rule</template>
            <template slot="body">
                <app-input
                    v-model="addForm.prefix"
                    placeholder="Prefix"
                    :error="addForm.errors.get('prefix')"
                    @updated="addForm.errors.clear('prefix')"
                    focus
                    required
                />
                <app-input
                    v-model="addForm.description"
                    placeholder="Description"
                    :error="addForm.errors.get('description')"
                    @updated="addForm.errors.clear('description')"
                    required
                />
                <app-select 
                    v-model="addForm.gwlist"
                    placeholder="Gateway"
                    :options="items.gateways"
                    label-key="description"
                    value-key="gwid"
                    required
                    :error="addForm.errors.get('gwlist')"
                    @updated="addForm.errors.clear('gwlist')"
                />
                <app-select 
                    v-model="addForm.groupid"
                    placeholder="Group"
                    :options="items.groups"
                    label-key="description"
                    value-key="id"
                    required
                    :error="addForm.errors.get('groupid')"
                    @updated="addForm.errors.clear('groupid')"
                />                
                <div class="text-right mt-5">
                    <app-button class="btn-white"
                        @click="showAddModal = false"
                    >Cancel</app-button>
                    <app-button
                        class="btn-blue ml-3"
                        :loading="adding"
                        @click="store"
                    >Add</app-button>
                </div>
            </template>
        </app-modal>
        <app-modal
            width="lg:w-1/3"
            :show.sync="showEditModal"
        >
            <template slot="header">Edit Rule</template>
            <template slot="body">
                <app-input
                    v-model="editForm.prefix"
                    placeholder="Prefix"
                    :error="editForm.errors.get('prefix')"
                    @updated="editForm.errors.clear('prefix')"
                    focus
                    required
                />
                <app-input
                    v-model="editForm.description"
                    placeholder="Description"
                    :error="editForm.errors.get('description')"
                    @updated="editForm.errors.clear('description')"
                    required
                />
                <app-select 
                    v-model="editForm.gwlist"
                    placeholder="Gateway"
                    :options="items.gateways"
                    label-key="description"
                    value-key="gwid"
                    required
                    :error="editForm.errors.get('gwlist')"
                    @updated="editForm.errors.clear('gwlist')"
                />
                <app-select 
                    v-model="editForm.groupid"
                    placeholder="Group"
                    :options="items.groups"
                    label-key="description"
                    value-key="id"
                    required
                    :error="editForm.errors.get('groupid')"
                    @updated="editForm.errors.clear('groupid')"
                />                
                <div class="text-right mt-5">
                    <app-button class="btn-white"
                        @click="showEditModal = false"
                    >Cancel</app-button>
                    <app-button
                        class="btn-blue ml-3"
                        :loading="updating"
                        @click="update"
                    >Update</app-button>
                </div>
            </template>
        </app-modal>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import Form from '@/helpers/Form';    
    
    export default {
        data() {
            return {
                showAddModal: false,
                showEditModal: false,
                adding: false,
                updating: false,                
                refreshTable: false,
                addForm: new Form({
                    prefix: null,
                    groupid: null,
                    gwlist: null,
                    description: null,
                }),
                editForm: new Form({
                    prefix: null,
                    groupid: null,
                    gwlist: null,
                    description: null,
                }),
                columns: [
                    {
                        title: 'Prefix',
                        field: 'prefix',
                        sorter: 'string',
                        minWidth: 200,
                    },
                    {
                        title: 'Description',
                        field: 'description',
                        sorter: 'string',
                        minWidth: 250,
                    },
                    {
                        title: 'Gateway',
                        field: 'gateway.description',
                        sorter: 'string',
                        minWidth: 200,
                    },
                    {
                        title: 'Group',
                        field: 'group.description',
                        sorter: 'string',
                        minWidth: 200,
                    },                    
                ],
                actions: [
                    {
                        label: 'Edit',
                        icon: () => import('@/icons/EditOutlined.vue'),
                        requiredSelect: true,
                        handler: rules => {
                            this.showEditModal = true;
                            this.editForm.set(rules[0]);
                            this.$store.commit('sip/rules/setSelected', rules[0]);                          
                        }
                    },
                    {
                        label: 'Clone',
                        icon: () => import('@/icons/FileCopyOutlined.vue'),
                        requiredSelect: true,
                        handler: this.clone,
                    },
                    {
                        label: 'Delete',
                        icon: () => import('@/icons/DeleteOutlined.vue'),
                        requiredSelect: true,
                        handler: rules => {
                            this.$store.commit('sip/rules/setSelected', rules[0]);
                            this.delete(rules[0]);
                        }
                    },
                    {
                        label: 'Add',
                        icon: () => import('@/icons/Add.vue'),
                        handler: this.add,
                    }
                ]
            }
        },
        computed: {
            ...mapGetters({
                items: 'sip/rules/items',
                selected: 'sip/rules/selected',          
            }),
        },
        methods: {            
            add() {
                this.showAddModal = true;
                this.addForm.reset();
                this.addForm.errors.clear();
            },
            handleRowSelected(row) {
                this.$store.commit('sip/rules/setSelected', row.data);
            },        
            store() {
                this.adding = true;
                this.addForm.errors.clear();
                this.$store.dispatch('sip/rules/store', this.addForm.payload())
                    .then(() => {
                        this.adding = false;
                        this.showAddModal = false;
                        this.refreshTable = true;
                        this.$swal.fire({
                            type: 'success',
                            title: 'Success!',
                            text: 'Rule was successfully added.'
                        })
                    })
                    .catch(({ response }) => {
                        this.adding = false;
                        this.addForm.errors.record(response.data);
                    })
            },
            update() {
                this.updating = true;
                this.editForm.errors.clear();                
                this.$store.dispatch('sip/rules/update', this.editForm.payload())
                    .then(() => {
                        this.updating = false;
                        this.showEditModal = false;
                        this.refreshTable = true;
                        this.$swal.fire({
                            type: 'success',
                            title: 'Success!',
                            text: 'Rule was successfully updated.'
                        })
                    })
                    .catch(({ response }) => {
                        this.updating = false;
                        this.editForm.errors.record(response.data);
                    })
            },
            delete(rule) {
                this.$swal.fire({
                    type: 'warning',
                    title: 'Are you sure?',
                    html: `You are about to delete rule with a prefix "<strong>${rule.prefix}</strong>" permanently.`,
                    showCancelButton: true,
                    confirmButtonColor: '#f56565',
                    confirmButtonText: 'Yes, delete it!',
                    showLoaderOnConfirm: true,
                    preConfirm: (response) => {
                        return this.$store.dispatch('sip/rules/delete');
                    },
                    allowOutsideClick: () => !this.$swal.isLoading()
                })
                .then((result) => {
                    if (result.value) {
                        this.refreshTable = true;
                        this.$swal.fire({
                            type: 'success',
                            title: 'Success!',
                            text: 'Rule was successfully deleted.'
                        })
                    }
                })                
            },
            clone(rules) {
                this.$store.commit('sip/rules/setSelected', rules[0]);
                this.$swal.fire({
                    type: 'warning',
                    title: 'Are you sure?',
                    html: `You are about to clone rule with a prefix "<strong>${rules[0].prefix}</strong>" permanently.`,
                    showCancelButton: true,
                    confirmButtonColor: '#3182ce',
                    confirmButtonText: 'Yes, clone it!',
                    showLoaderOnConfirm: true,
                    preConfirm: (response) => {
                        return this.$store.dispatch('sip/rules/clone');
                    },
                    allowOutsideClick: () => !this.$swal.isLoading()
                })
                .then((result) => {
                    if (result.value) {
                        this.refreshTable = true;
                        this.$swal.fire({
                            type: 'success',
                            title: 'Success!',
                            text: 'Rule was successfully cloned.'
                        })
                    }
                })
            }               
        }
    }
</script>